import PropTypes from 'prop-types';
import { Box, Title } from '@nerdwallet/currency';
import Image from '@nerdwallet/react-image';
import styles from './impact-pyramid.module.less';
import PyramidLabel from './pyramid-label';

const PyramidItemBadge = ({ item }) => (
  <Box id="badge-container" className={styles.badgeContainer}>
    <PyramidLabel
      backgroundColor={item.labelBackgroundColor}
      color={item.labelTextColor}
    >
      {item.topLabelText}
    </PyramidLabel>
    <Box
      className={styles.badgeCircle}
      style={{ backgroundColor: item.badgeColor }}
    >
      <PyramidLabel className={styles.badgeText} disableShadow>
        {item.badgeText}
      </PyramidLabel>
      <Title style={{ color: item.badgeTextColor }} size={item.badgeValueSize}>
        {item.badgeValue}
      </Title>
      <Image
        className={styles[item.badgeImagePlacement]}
        src={item.badgeImage}
        backgroundColor="transparent"
      />
    </Box>
    <Box style={{ height: 53 }}>
      <PyramidLabel
        backgroundColor={item.labelBackgroundColor}
        color={item.labelTextColor}
        className={styles.bottomLabelBox}
      >
        {item.bottomLabelText}
      </PyramidLabel>
    </Box>
  </Box>
);

PyramidItemBadge.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    labelTextColor: PropTypes.string,
    labelBackgroundColor: PropTypes.string,
    topLabelText: PropTypes.string,
    bottomLabelText: PropTypes.string,
    badgeText: PropTypes.string,
    badgeValue: PropTypes.string,
    badgeValueSize: PropTypes.oneOf(['default', 'small']),
    badgeImage: PropTypes.string,
    badgeImagePlacement: PropTypes.oneOf(['topRight', 'bottom']),
    badgeColor: PropTypes.string,
    badgeTextColor: PropTypes.string,
    description: PropTypes.string,
    descriptionColor: PropTypes.string,
    layout: PropTypes.oneOf(['vertical', 'horizontal']),
  }),
};

export default PyramidItemBadge;
